<template>
  <nav
    class="navbar navbar-expand d-flex justify-content-between px-4"
    v-if="authenticated"
  > 
    <!-- Button Toggle Fixed -->
    <div>
      <button
        class="btn btn-link btn-md d-none d-lg-block text-black"
        id="sidebarToggle"
        href="#"
      >
        <i class="fas fa-bars" />
      </button>
    </div>

    <div class="rounded-pill d-flex align-items-center gap-3 py-1 px-2 bg-white shadow-sm">
      <!-- Profile picture -->
      <div class="d-flex align-items-center">
        <div class="user-profile-image rounded-pill overflow-hidden me-2 flex-shrink-0">
          <img src="/assets/img/default_user.webp" class="img-fluid" alt="Foto de usuario">
        </div>        
        <span class="user-profile-name">{{ user.name }}</span>
      </div>

      <!-- Weather View -->
      <weather-view />

      <!-- Notifications -->
      <div class="notification-bell position-relative">
        <i class="mdi mdi-bell-outline"></i>
        <span class="badge bg-primary">0</span>
      </div>

      <!-- Logout -->
      <button
        class="btn btn-portal btn-md rounded-pill flex-shrink-0"      
        @click.prevent="signOut"
      >
        Salir <i class="fas fa-sign-out-alt" />
      </button>
    </div>         
  </nav>    
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import WeatherView from "../../views/weather_view/WeatherView.vue";
export default {  
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user",
    }),
  },
  components: {
    WeatherView
  },  
  methods: {
    ...mapActions({
      signOutAction: "auth/signOut",
    }),
    signOut() {
      this.signOutAction().then(() => {
        this.$router.replace({
          name: "SignIn",
        });
      });
    },
  },
};
</script>

<style scoped>
.user-profile-image {
  width: 40px; 
  height: 40px;
}

.user-profile-name {
  font-size: 12px;
  font-weight: bold;
}

.notification-bell i {
  font-size: 22px;
}

.notification-bell span {
  font-size: 11px;
  padding: 2px 4px;
  position: absolute;
  right: -6px;
}
</style>
